export type inputTypesKeys =
  | 'TEXT'
  | 'NUMBER'
  | 'PHONE'
  | 'URL'
  | 'ZIP'
  | 'EMAIL'

export enum inputTypes {
  TEXT = 'lp-input',
  NUMBER = 'lp-number-input',
  PHONE = 'lp-phone-input',
  URL = 'lp-url-input',
  ZIP = 'lp-zip-input',
  EMAIL = 'lp-email-input',
}
